// PX module (management.modules, P3-53776) that gives access to integrations: `code` for the account
// (user.siteOptions) and `userCode` for sub-users (user.options). Permissions are referenced by code across the app.
export const INTEGRATIONS_PERMISSION = 'intgrtns';
export const INTEGRATIONS_SUB_USER_PERMISSIONS = [374];

// A key the app accepted that can also read the fleet's vehicles (what the sync needs). vehicleAccess null means it
// could not be verified, which does not block: the sync reads the vehicles later
export const keyAccepted = (check) => !!check?.authenticated && check?.vehicleAccess !== false;

// Same mask as the API (apiKeyMasked): 8 dots and the last 4 characters. Used for the key typed in the wizard.
export const maskApiKey = (key) => (key ? `••••••••${key.slice(-4)}` : '');

// Product name shown in the wizard copy: the reseller's title on white-label accounts, the default product otherwise
export const getProductName = (reseller, defaultName) => reseller?.title || defaultName;
